import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("rc_cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("rc_cookie_consent", "accepted");
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem("rc_cookie_consent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-50 bg-[#2A3229] text-[#F6F3EF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
        <p className="text-sm text-[#F6F3EF]/85 leading-relaxed max-w-3xl">
          Utilizziamo cookie tecnici per garantire il corretto funzionamento del sito e dell'area riservata. Proseguendo acconsenti al loro utilizzo. Consulta la{" "}
          <Link to="/privacy" className="underline text-[#FAC075]" data-testid="cookie-privacy-link">Privacy &amp; Cookie Policy</Link>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button data-testid="cookie-reject" onClick={reject} className="px-5 py-2.5 border border-[#F6F3EF]/40 text-[#F6F3EF] text-xs uppercase tracking-[0.18em] font-semibold hover:bg-[#F6F3EF]/10 transition-colors">
            Rifiuta
          </button>
          <button data-testid="cookie-accept" onClick={accept} className="px-5 py-2.5 bg-[#FAC075] text-[#2A3229] text-xs uppercase tracking-[0.18em] font-semibold hover:bg-[#E8A050] transition-colors">
            Accetto
          </button>
        </div>
      </div>
    </div>
  );
}
